<script setup lang="ts">
import type { FlatPriceHistory } from '~/types/types'

const props = defineProps<{
  flatPriceHistory: FlatPriceHistory[] | null
  open: boolean
}>()

const emit = defineEmits(['close'])
</script>

<template>
  <div
    class="flex items-center justify-center fixed top-0 z-110 w-svw h-svh bg-black/80 transition-all duration-200"
    :class="props.open ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'"
  >
    <div class="bg-background-2 rounded-3xl p-10 flex flex-col gap-10">
      <div class="flex flex-row gap-16 justify-between items-center">
        <span class="text-H4 text-Tekst">Historia zmian cen</span>
        <div
          class="p-2 cursor-pointer"
          @click="emit('close')"
        >
          <i class="pi pi-times text-Tekst" />
        </div>
      </div>
      <div class="flex flex-col">
        <table
          v-if="flatPriceHistory && flatPriceHistory.length > 0"
          class="w-full border-collapse"
        >
          <thead class="rounded-full sticky top-31.5">
            <tr class="rounded-full bg-Tekst text-Paragraph text-white font-normal">
              <th class="text-center py-2.5 px-10 rounded-l-full">
                Cena przed
              </th>
              <th class="text-center py-2.5 px-10">
                Cena po
              </th>
              <th class="text-center py-2.5 px-10 rounded-r-full">
                Data zmiany
              </th>
            </tr>
          </thead>
          <tbody class="max-h-50svh">
            <tr
              v-for="history in flatPriceHistory"
              :key="JSON.stringify(history)"
              class="border-b border-Tertiary last:border-0 text-center text-Tekst text-Paragraph"
            >
              <td class="py-2.5">
                {{ history.before_price_formatted || '-' }}
              </td>
              <td class="py-2.5">
                {{ history.after_price_formatted || '-' }}
              </td>
              <td class="py-2.5">
                {{ history.date_modified || '-' }}
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <span>brak historii cen</span>
        </div>
      </div>
    </div>
  </div>
</template>
